'use strict';

export default function PartnerUtilitiesService() {
  var toggleSelection = function toggleSelection(selection, selected) {
    var idx;
    idx = selected.indexOf(selection);
    if (idx > -1) {
      selected.splice(idx, 1);
    } else {
      selected.push(selection);
    }
  };

  var toggleById = function toggleById(needle, haystack) {
    var effingIds = haystack.map(function(straw) {
      return straw.id;
    });
    var idx = effingIds.indexOf(needle.id);
    if (idx >= 0) {
      haystack.splice(idx, 1);
    } else {
      haystack.push(needle);
    }
  };

  var validatePartnerOutcome = function validatePartnerOutcome(partner) {
    var errors = [];

    if (!validVvaPartner(partner)) {
      errors.push('None of the sites selected support video view ads.');
    }

    return { successful: errors.length === 0, errors: errors };
  };

  function validVvaPartner(partner) {
    return (
      !partner.hasAdType('native_outstream') ||
      partner.sites.some(function(site) {
        return site.instantPlayEnabled;
      })
    );
  }
  return {
    toggleById: toggleById,
    toggleSelection: toggleSelection,
    validatePartnerOutcome: validatePartnerOutcome
  };
}

PartnerUtilitiesService.$inject = [];
